export const WordViewer = ({ file }) => {
    return (
        <>
        <h2 className="text-xl font-bold p-8 pb-4">{file?.title}</h2>
        <div className="card bg-base-100 shadow-xl">
            <div className="card-body p-0">
                <iframe
                    className='w-full h-[90vh]'
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file?.url)}`}
                />
            </div>
        </div>
        </>
)
}